import { RouteProp, useRoute, useNavigation } from "@react-navigation/native";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ImageBackground,
  Dimensions,
  StyleSheet,
  useWindowDimensions,
  Platform,
  ActivityIndicator,
} from "react-native";
import Carousel from "react-native-reanimated-carousel";
// import { NavigationProp } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import { RootStackParamList } from "../../navigator";
import { TableItem } from "../../../store/types";
import { getSocket } from "../../../services/socket";
import { RootState } from "../../../store";
import { roomOpen } from "../../../store/room/roomActions";
import PokerTable from "../LobbyTable/PokerTable";
import { LeftArrowPng, RightArrowPng } from "../../../assets";
import { useDevice } from "../../../utils/hooks/useDevice";
import InviteNotificationModal from "../Modals/InviteNotificationModal";
import LeveledUpNotificationModal from "../Modals/LeveledUpNotificationModal";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
interface InviteData {
  name: string;
  username: string;
  table: string;
  table_name: string;
  url: string;
  inviteId: string;
  inviterPlayerId: string;
  inviterUsername: string;
  tableName: string;
}
type NavigationProp = NativeStackNavigationProp<RootStackParamList, "Game">;
type Props = { route: { params: { roomSlug: string } }; navigation: any };
export type RoomRoute = RouteProp<RootStackParamList, "Room">;
// const width = Dimensions.get("window").width;

export const RoomTablesSection = ({ route }: Props) => {
  const { width, height } = useWindowDimensions();
  const { isDesktop, isLandscape, isPortrait } = useDevice();
  const isMobile = width < 768;
  const isTablet = width > 768 && width < 980;
  const { isXLg, isLg, isNative } = useDevice();
  const itemsPerPage =
    (isMobile && isPortrait) || (isTablet && isPortrait) ? 1 : 3;
  const isSmall = isLandscape && width < 980;

  const [inviteData, setInviteData] = useState<InviteData | null>(null);
  const [showInviteNotification, setShowInviteNotification] = useState(false);
  const [showLeveledUpNotification, setShowLeveledUpNotification] =
    useState(false);
  const [newLevel, setNewLevel] = useState(0);
  const [isClient, setIsClient] = useState(false);
  const carouselRef = useRef<any>(null);
  const [loading, setLoading] = useState(true);
  const [showArrows, setShowArrows] = useState(true);
  const [tablesLocal, setTablesLocal] = useState<TableItem[]>([]);
  // const navigation: NavigationProp<RootStackParamList> = useNavigation();
  const navigation = useNavigation<NavigationProp>();

  const { params } = useRoute<RoomRoute>();
  const auth = useSelector((state: RootState) => state.auth);

  const roomIdRef = useRef<string | number | undefined>(params?.roomId);
  useEffect(() => {
    roomIdRef.current = params?.roomId;
  }, [params?.roomId]);

  useEffect(() => {
    const playerId = auth.user?.id || "anonymous";
    const username = auth.user?.username || "anonymous";
    const { roomId } = params;

    const socket = getSocket(playerId, username);
    const roomPayload = { roomId };

    const onConnect = () => {
      console.log("[io] connected", socket.id);
      socket.emit("service:getTables", roomPayload);
    };

    const onAny = (event: string, payload?: any) => {
      console.log("<<<", event, payload);
      if (event === "inviteUser") {
        console.log("INVITE RECEIVED:", payload);
        const data = payload.data || payload;

        const invitePayload = {
          name: data.name || data.inviterUsername,
          username: data.username || data.inviterUsername,
          table: data.table,
          table_name: data.table_name || data.tableName,
          url: data.url,
          inviteId: data.notification_id || data.inviteId,
          inviterPlayerId: data.inviterPlayerId,
          inviterUsername: data.inviterUsername,
          tableName: data.tableName,
        };

        console.log("Setting invite data:", invitePayload);
        setInviteData(invitePayload);
        setShowInviteNotification(true);
        return;
      } else if (event === "levelUP") {
        const data = payload.data || payload;
        setNewLevel(data.level || 0);
        setShowLeveledUpNotification(true);
        return;
      } else if (event === "quickSeat") {
        console.log("Quick seat event in RoomTablesSection:", payload);
        const data = payload?.data || payload || {};

        if (payload?.success && data.tableId) {
          console.log(
            "Navigating to table from RoomTablesSection:",
            data.tableId,
          );
          navigation.replace("Game", {
            tableId: data.tableId,
            roomSlug: data.roomSlug,
            isTournamentRoom: false,
          });
        }
        return;
      }
      const maybeTables =
        (payload && Array.isArray(payload.data) && payload.data) || // { data: [...] }
        (payload && Array.isArray(payload.items) && payload.items) || // { items: [...] }
        (Array.isArray(payload) && payload); // [...] directly

      if (maybeTables.length) {
        const filtered = maybeTables.filter(
          (t: any) => String(t.room_id) === String(roomIdRef.current),
        );
        console.log(filtered);
        setTablesLocal(filtered.length ? filtered : maybeTables);
        setLoading(false);
      }

      if (payload && payload.success === false && payload.error) {
        console.warn(`[SOCKET ERROR] ${event}:`, payload.error);
      }
    };

    const onGetTables = (packet: any) => {
      console.log("[SOCKET] getTables:", packet);
      const arr =
        (packet && Array.isArray(packet.data) && packet.data) ||
        (packet && Array.isArray(packet.items) && packet.items) ||
        (Array.isArray(packet) && packet) ||
        [];

      const currentRoomId = roomIdRef.current;

      const filtered = currentRoomId
        ? arr.filter((t: any) => String(t.room_id) === String(currentRoomId))
        : arr;

      console.log("rooms", filtered);
      setTablesLocal(filtered);
      setLoading(false);
    };

    socket.on("connect", onConnect);

    socket.onAny(onAny);
    socket.on("getTables", onGetTables);
    socket.on("getTable", (p) => console.log("[SOCKET] loadedTable:", p));
    socket.on("getClosedTables", (p) =>
      console.log("[SOCKET] getClosedTables:", p),
    );

    return () => {
      socket.off("connect", onConnect);

      socket.offAny(onAny);
      socket.off("getTables", onGetTables);
      socket.off("getTable");
      socket.off("getClosedTables");
      // socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const playerId = auth.user?.id || "anonymous";
    const username = auth.user?.username || "anonymous";
    const { roomId } = params;
    if (!roomId) return;

    const socket = getSocket(playerId, username);
    const roomPayload = { roomId };

    const emitForRoom = () => {
      console.log("[emit] service:getTables for room", roomId);
      socket.emit("service:getTables", roomPayload);
    };

    if (socket.connected) {
      emitForRoom();
    } else {
      socket.once("connect", emitForRoom);
    }

    return () => {
      socket.off("connect", emitForRoom);
    };
  }, [params?.roomId, auth.user?.id, auth.user?.username]);

  const dispatch = useDispatch();
  const { room, tables, error } = useSelector((s: RootState) => s.room);
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     setIsClient(true);
  //   }
  // }, []);
  useEffect(() => {
    setIsClient(Platform.OS !== "web" ? true : typeof window !== "undefined");
  }, []);

  useEffect(() => {
    if (params?.roomId) {
      setLoading(true);
      dispatch(roomOpen({ roomId: String(params.roomId) }));
    }
  }, [params?.roomId, dispatch]);

  const pages: TableItem[][] = useMemo(() => {
    const out: TableItem[][] = [];
    for (let i = 0; i < tablesLocal.length; i += itemsPerPage) {
      out.push(tablesLocal.slice(i, i + itemsPerPage));
    }

    return out;
  }, [tablesLocal, itemsPerPage]);

  const handleNext = () => {
    setShowArrows(false);
    carouselRef.current?.next();
  };

  const handlePrev = () => {
    setShowArrows(false);
    carouselRef.current?.prev();
  };
  const handleAcceptInvite = () => {
    if (!inviteData) return;

    const playerId = auth.user?.id || "anonymous";
    const username = auth.user?.username || "anonymous";
    const socket = getSocket(playerId, username);

    const responsePayload = {
      inviteId: inviteData.inviteId,
      response: "accept",
      table: inviteData.table,
    };

    socket.emit("svara:respondToInvite", responsePayload);

    setShowInviteNotification(false);
    const urlParts = inviteData.url.split("/");
    const roomSlug = urlParts[2];
    const tableName = urlParts[3];

    console.log("Navigating to:", {
      roomSlug,
      tableName,
      table: inviteData.table,
    });

    navigation.navigate("Game", {
      roomSlug,
      tableName,
      tableId: inviteData.table,
    });

    setInviteData(null);
  };

  const handleRejectInvite = () => {
    if (!inviteData) return;

    const playerId = auth.user?.id || "anonymous";
    const username = auth.user?.username || "anonymous";
    const socket = getSocket(playerId, username);

    const responsePayload = {
      inviteId: inviteData.inviteId,
      response: "reject",
      table: inviteData.table,
    };

    socket.emit("svara:respondToInvite", responsePayload);
    setShowInviteNotification(false);
    setInviteData(null);
  };

  if (!isClient) return null;

  // const hasRooms = Array.isArray(rooms) && rooms.length > 0;
  console.log("pages", pages);
  return (
    <>
      <View
        style={[
          styles.container,
          {
            marginTop: isSmall ? 0 : 40,
            justifyContent: "center",
            width: isPortrait ? width : width * 0.9,
            margin: "auto",
            alignItems: "center",
            height: isDesktop ? "100%" : "auto",
            minHeight: loading ? height * 0.5 : undefined,
            flex: loading ? 1 : undefined,
          },
        ]}
      >
        {loading ? (
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ActivityIndicator size="large" color="#B7C1D1" />
            {/* <Text style={{ color: "#B7C1D1", marginTop: 8 }}>
              Loading tables…
            </Text> */}
          </View>
        ) : (
          <>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginTop: isSmall ? 0 : 40,
              }}
            >
              <Carousel
                ref={carouselRef}
                loop
                width={isSmall ? width * 0.7 : width}
                height={
                  isMobile || isTablet
                    ? height * 0.6
                    : isSmall
                      ? height * 0.5
                      : height * 0.75
                }
                autoPlay={false}
                data={pages}
                // data={tablesLocal}
                scrollAnimationDuration={1200}
                onScrollEnd={() => setShowArrows(true)}
                // renderItem={({ item }) => (
                //   <PokerTable room={item} totalCount={tablesLocal.length} />
                // )}
                renderItem={({ item: page, index: pageIndex }) => (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent:
                        isMobile || isTablet ? "center" : "center",
                      alignItems: "center",
                      width: isPortrait ? width : width * 0.65,
                      paddingHorizontal: 8,
                      marginHorizontal: "auto",
                      height: "100%",
                    }}
                  >
                    {page.map((room, itemIndex) => {
                      const globalIndex = pageIndex * itemsPerPage + itemIndex;
                      const cardWidth = isMobile
                        ? width - 32
                        : isSmall
                          ? width * 0.2
                          : width * 0.2;
                      return (
                        <View
                          key={room.id ?? globalIndex}
                          style={{
                            width: cardWidth,
                            marginHorizontal: 8,
                            alignItems: "center",
                            justifyContent: isDesktop
                              ? "space-evenly"
                              : "center",
                            height: isNative ? "auto" : "100%",
                            minHeight: isXLg
                              ? height * 0.7
                              : isLg
                                ? height * 0.6
                                : isMobile
                                  ? 450
                                  : isSmall
                                    ? 200
                                    : height * 0.6,
                          }}
                        >
                          <PokerTable
                            key={room.id ?? itemIndex}
                            room={room}
                            totalCount={tablesLocal.length}
                            itemIndex={globalIndex}
                          />
                        </View>
                      );
                    })}
                  </View>
                )}
              />
            </View>
            <>
              <TouchableOpacity style={styles.arrowLeft} onPress={handlePrev}>
                <ImageBackground
                  source={LeftArrowPng}
                  resizeMode="cover"
                  style={styles.arrowBg}
                  imageStyle={styles.arrowImage}
                />
              </TouchableOpacity>

              <TouchableOpacity style={styles.arrowRight} onPress={handleNext}>
                <ImageBackground
                  source={RightArrowPng}
                  resizeMode="cover"
                  style={styles.arrowBg}
                  imageStyle={styles.arrowImage}
                />
              </TouchableOpacity>
            </>
          </>
        )}
      </View>

      {showInviteNotification && inviteData && (
        <InviteNotificationModal
          visible={showInviteNotification}
          inviteData={inviteData}
          onAccept={handleAcceptInvite}
          onReject={handleRejectInvite}
        />
      )}

      {showLeveledUpNotification && newLevel && (
        <LeveledUpNotificationModal
          visible={showLeveledUpNotification}
          level={newLevel}
          onClose={() => setShowLeveledUpNotification(false)}
        />
      )}
    </>
  );
};

export default RoomTablesSection;

const styles = StyleSheet.create({
  container: {
    position: "relative",

    height: 450,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
  },
  arrowLeft: {
    position: "absolute",
    top: "45%",
    left: 10,
    borderRadius: 20,
    zIndex: 10,
  },
  arrowRight: {
    position: "absolute",
    top: "45%",
    right: 10,
    borderRadius: 20,
    zIndex: 10,
  },
  arrowBg: {
    width: 50,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    padding: 10,
  },
  arrowImage: {
    borderRadius: 20,
  },
});
